// 游戏的个人状态
export interface IGameStat {
    gamePlayedTotal?: number;  // 游戏总场次
    gameWinTotal?: number;     // 游戏胜利场次
    averageGuess?: number;     // 平均猜词次数
    bestStreak?: number;       // 对战最高连胜等级
    winRate?: number;          // 胜率
}

export interface IGameRecord {
    dailyBestRank: number; // 每日游戏最高排行
    dailyAverageTime: number; // 游戏胜利平均猜词次数
    weeklyBestWin: number; // 平均猜词次数
    bestStreak: number; // 对战最高连胜等级
}

// 每日游戏的状态
export interface DailyWordStat {
    wordId?: string;
    word?: string;
    hardTime?: number; // 挑战模式的猜词时间
    type?: string;
    wordPicUrl?: string;
    newUrl?: string;
    nextTime?: number;
    wordTitle?: string;
    popularSay?: string;
    wordIssue?: number;
    hasShowTip?: boolean;
    playedStatus?: number;
}

// challenge的关卡单词
export interface IChallengeWord {
    word: string;
    aiTime: number;
    hardTime: number;
    hardLevel: number;
}

export enum LocalStorageKey {
    TOKEN = "token",

    HOME_APP_DOWNLOAD_DIALOG = "home_app_download_dialog",
    DAILY_CORRECT_WORD = "daily_correct_word",
    DAILY_INPUT_WORDS = "daily_input_words",
    DAILY_GAME_STATUS = "daily_game_status",
    DAILY_TIP_STATUS = "daily_tip_status", // 是否弹出过一次每日游戏的提示的标记key
    DAILY_HINT = "daily_hint", // 每日游戏的hint单词
    DAILY_COUNT_DOWN_TIME = "count_down_time", // 每日游戏倒计时时间
    CHALLENGE_TIP_STATUS = "challenge_tip_status", // 是否弹出过一次AI挑战游戏的提示的标记key
    GAME_STATS = "game_stats",
    USER = 'user', // 本地用户
    AI_CHALLENGE_INPUT_WORDS = "ai_challenge_input_words", // AI对战，已经输入的单词
    AI_CHALLENGE_CORRECT_WORD = "ai_challenge_correct_word", // AI对战，正确的单词
    AI_CHALLENGE_GAME_LEVEL = "ai_challenge_game_level", // AI对战，当前处于几级
    AI_CHALLENGE_GAME_COUNT_SECONDS = "ai_challenge_game_count_seconds", // AI对战，当前级别所使用的时间秒数
}